// FadeIn: content that fades in when it mounts, for one state of a slot giving way to another
// (a picker to its pick, a list to a board, one peeked record to the next). Key it by the state
// so each swap runs again. It has no exit; a thing that comes and goes is Appear or Reveal.
// docs/operations/design-standard.md, "Motion".

import React, { useEffect, useState } from 'react';

export interface FadeInProps {
  children: React.ReactNode;
  className?: string;
}

export const FadeIn: React.FC<FadeInProps> = ({ children, className = '' }) => {
  const [on, setOn] = useState(false);
  useEffect(() => {
    // Two frames: the transparent state has to paint once or nothing fades.
    if (typeof requestAnimationFrame !== 'function') { setOn(true); return undefined; }
    let second = 0;
    const first = requestAnimationFrame(() => { second = requestAnimationFrame(() => setOn(true)); });
    return () => { cancelAnimationFrame(first); cancelAnimationFrame(second); };
  }, []);
  return (
    <div className={`transition-opacity duration-standard ease-emphasized ${on ? 'opacity-100' : 'opacity-0'} ${className}`}>
      {children}
    </div>
  );
};

export default FadeIn;
